export default {
  'subscriptionList.title': '订阅记录',
  'subscriptionList.form.shopifyId': 'Shopify 店铺 ID',
  'subscriptionList.form.shopifyId.placeholder': 'Shopify 店铺 ID',
  'subscriptionList.form.status': '订阅状态',
  'subscriptionList.form.status.placeholder': '请选择订阅状态',
  'subscriptionList.form.customerEmail': '客户邮箱',
  'subscriptionList.form.customerEmail.placeholder': '客户邮箱（模糊）',
  'subscriptionList.form.originalOrderId': '原始订单 ID（首单）',
  'subscriptionList.form.originalOrderId.placeholder': '原始订单 ID（首单）',
  'subscriptionList.form.subscriptionOrderId': '当次订单 ID',
  'subscriptionList.form.subscriptionOrderId.placeholder': '当次订单 ID',
  'subscriptionList.form.dateRange': '日期范围',
  'subscriptionList.form.startDate': '开始日期',
  'subscriptionList.form.endDate': '结束日期',
  'subscriptionList.form.search': '查询',
  'subscriptionList.form.reset': '重置',
  'subscriptionList.columns.index': '#',
  'subscriptionList.columns.shopifyId': 'Shopify 店铺 ID',
  'subscriptionList.columns.customerEmail': '客户邮箱',
  'subscriptionList.columns.status': '状态',
  'subscriptionList.columns.originalOrderId': '原始订单 ID',
  'subscriptionList.columns.subscriptionOrderId': '当次订单 ID',
  'subscriptionList.columns.createdAt': '创建时间',
  'subscriptionList.columns.updatedAt': '更新时间',
  'subscriptionList.columns.operations': '操作',
  'subscriptionList.columns.operations.unsubscribe': '退订',
  'subscriptionList.columns.operations.unsubscribeConfirm':
    '确认退订该订阅？',
  'subscriptionList.columns.operations.unsubscribeSuccess': '退订成功',
  'subscriptionList.columns.operations.unsubscribeError': '退订失败',
  'subscriptionList.status.active': '活跃',
  'subscriptionList.status.paused': '暂停',
  'subscriptionList.status.cancelled': '已取消',
  'subscriptionList.status.failed': '失败',
  'subscriptionList.status.expired': '已过期',
  'subscriptionList.status.renewed': '已续费',
};
